import { c as _c } from "react/compiler-runtime";
import { Flex, FlexColumn, Media, SkeletonBlock, SkeletonLine, SpaceBetween, TextBody, TextBodySkeleton, TextHeadingSkeleton } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { useTranslations } from "next-intl";
import { mintModuleContentClasses, mintScheduleRowClasses, mintStageIndicator } from "../../styles";
import { MintFeedTableSkeleton } from "../MintFeed";
import { SalesFeedTableSkeleton } from "../SalesFeed";
function PreviewImagesSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonBlock className="aspect-square h-auto w-full overflow-hidden rounded-lg" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<Flex className="mt-4 w-full gap-4">{range(4).map(_temp)}</Flex></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(index) {
  return <SkeletonBlock className="aspect-square basis-1/4 overflow-hidden rounded-lg" key={index} />;
}
function FeedsSkeleton() {
  const $ = _c(17);
  const t = useTranslations("MintModule");
  let t0;
  if ($[0] !== t) {
    t0 = t("liveMints");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody className="font-mono uppercase" weight="semibold">{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-full overflow-hidden [mask-image:linear-gradient(to_bottom,black_theme(spacing.6),black,transparent)]"><MintFeedTableSkeleton /></div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <FlexColumn className="h-[220px] lg:col-span-6 lg:h-[440px]">{t1}{t2}</FlexColumn>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("liveSales");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <TextBody className="font-mono uppercase" weight="semibold">{t4}</TextBody>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="h-full overflow-hidden [mask-image:linear-gradient(to_bottom,black_theme(spacing.6),black,transparent)]"><SalesFeedTableSkeleton /></div>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <FlexColumn className="h-[220px] lg:col-span-6 lg:h-[440px]">{t5}{t6}</FlexColumn>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t7) {
    t8 = <div className="mt-6 flex flex-col gap-6 lg:mt-10 lg:grid lg:grid-cols-12 lg:gap-10">{t3}{t7}</div>;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
export function MintModuleSkeleton() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Media greaterThanOrEqual="lg"><FlexColumn className="col-span-5"><PreviewImagesSkeleton /></FlexColumn></Media>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = mintModuleContentClasses();
    t2 = <TextHeadingSkeleton className="w-[400px]" size="lg" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FlexColumn className="gap-3"><SpaceBetween><TextBodySkeleton className="w-[80px]" size="sm" /><TextBodySkeleton className="w-[60px]" size="sm" /></SpaceBetween><SkeletonLine className="h-3 w-full" /></FlexColumn>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Media lessThan="lg"><FlexColumn><PreviewImagesSkeleton /></FlexColumn></Media>;
    t5 = <SkeletonBlock className="h-[104px] w-full rounded-md" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SpaceBetween className="mb-6 items-center"><TextBodySkeleton className="w-[100px]" size="sm" /><SkeletonBlock className="h-8 w-[120px] rounded" /></SpaceBetween>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ol className="space-y-10">{range(3).map(_temp2)}</ol>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Flex className="my-7 grid w-full grid-cols-12 justify-center gap-8">{t0}<FlexColumn className={t1}>{t2}{t3}{t4}{t5}<FlexColumn className="mt-4">{t6}{t7}<Media greaterThanOrEqual="xl"><FeedsSkeleton /></Media></FlexColumn></FlexColumn></Flex>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <>{t8}<Media lessThan="xl"><FeedsSkeleton /></Media></>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}
function _temp2(index) {
  return <SpaceBetween asChild={true} className={mintScheduleRowClasses()} key={index}><li><Flex className="relative items-center gap-6">{index !== 2 ? <div className="absolute top-1/2 left-3 z-0 mt-3 h-[76px] w-0 border-border-1 border-l" /> : null}<div className={mintStageIndicator()} /><FlexColumn><TextBodySkeleton className="w-[100px]" /><TextBodySkeleton className="w-[200px]" size="sm" /><TextBodySkeleton className="w-[300px]" size="xs" /></FlexColumn></Flex></li></SpaceBetween>;
}